<div class="alerta_error" id="alerta_error">
    <div class="alerta_mensaje" [ngClass]="{'mensaje_error':tipo == 'error', 'mensaje_warning':tipo == 'warning'}">
        <div class="css-Icono_alerta_error_-1 icono_alerta_error_"><img
                [src]="tipo == 'error' ? 'assets/images/vectors82931858.svg' : 'assets/images/vectors82931859.svg'"
                width="16px" height="16px" class="css-Vector_vector-1 vector_vector"></div>
        <div class="contenido_alerta" *ngIf="mensaje_unico.length == 0">
            <p class="titulo_alerta" [ngClass]="{
                    'titulo_alerta_error':tipo == 'error', 
                    'titulo_alerta_warning':tipo == 'warning'
                }">Tiene {{errores
                ? errores.length : 0}}
                {{errores && errores.length>1 ?"errores" : "error"}} en el formulario</p>
        </div>
        <div class="contenido_alerta" *ngIf="mensaje_unico.length > 0">
            <p class="titulo_alerta" [ngClass]="{
                    'titulo_alerta_error':tipo == 'error', 
                    'titulo_alerta_warning':tipo == 'warning'
                }">{{mensaje_unico}}</p>
        </div>
    </div>
</div>